import styles from './avatar.module.scss';

interface AvatarProps {
    initials?: any;
    icon?: string; // Optional custom icon
    color?: string; // Optional custom color
    size?: 'xs' | 'sm' | 'md' | 'lg';
    invert?: boolean;
}

export const Avatar = ({
    initials,
    size = 'md',
    icon,
    color,
    invert = false,
}: AvatarProps) => {
    return (
        <span
            className={`${styles.avatar} ${styles[size]} ${invert ? styles.invert + ' invert' : ''}`}
            style={{ backgroundColor: color }}
        >
            {initials ? (
                <span className={styles.initials}>{initials}</span>
            ) : (
                <i className={icon}></i>
            )}
        </span>
    );
};

export default Avatar;